import { render } from "./chat.svg?vue&type=template&id=35471fb2?inline"
const script = {}

import exportComponent from "/home/buddymetal/actions-runner/_work/candidate/candidate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__